import { App } from "../components/common/store/types";
import { DEFAULT_PROPS_LEAGUE, getPropsRouteLeague } from "../components/stokasticProps/data/leagueConfig";

/**
 * @param league       the current tool's league (URL / Redux) — drives the DFS tool links
 * @param propsLeague  league the Props link lands on. Entering Props from another tool or the
 *                     landing page uses the seasonal default so first-time visitors see a full
 *                     slate; the header passes the current league only while already inside Props.
 */
export const primaryLinks = (league: string, queryParams: string, propsLeague: string = DEFAULT_PROPS_LEAGUE) => [
  {
    name: 'Data Hub',
    description: 'Browse the most accurate and sophisticated DFS data in the DFS industry.',
    link: `/datahub/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
    isMobileSupported: true,
    view: App.DATA_HUB,
  },
  {
    name: 'Props',
    description: 'Find +EV player props with projections and EV calculations.',
    link: `/props/${getPropsRouteLeague(propsLeague)}`,
    isMobileSupported: true,
    view: App.PROPS,
    isBeta: false,
  },
];

export const simsLinks = (league: string, queryParams: string) => [
  {
    name: 'Contest Generator',
    description: 'Quickly and effectively create a pool of lineups that closely mirror projected ownership for the selected slate.',
    link: `/contestgenerator/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
    isMobileSupported: false,
    view: App.CONTEST_GENERATOR,
  },
  {
    name: 'Single-Lineup Simulator',
    description: 'Hand-build DFS lineups and dominate single-entry contests.',
    link: `/singlelineupsim/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
    view: App.SINGLE_LINEUP_SIMULATOR,
    isMobileSupported: true,
  },
  {
    name: 'Pre-Contest Simulator',
    description: "Use simulations to consider your competitors' lineups and range of outcomes. Identify top ROI lineups in minutes.",
    link: `/precontestsimulator/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
    isMobileSupported: false,
    view: App.PRE_CONTEST_SIMULATOR,
  },
  {
    name: 'Late Swap',
    description: 'Hand picked bets from the sharpest experts in the business.',
    link: `/lateswap/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
    isMobileSupported: false,
    view: App.LATE_SWAP_SIMULATOR,
  },
  {
    name: 'Post-Contest Simulator',
    description: 'Review your lineups from complete contests using simulations to learn how to improve your process.',
    link: `/postcontestsimulator/${league}${queryParams?.toString() ? `?${queryParams.toString()}` : ''} `,
    isMobileSupported: false,
    view: App.POST_CONTEST_SIMULATOR,
  },
];

export const analyticsLinks = (_league: string, _queryParams: string) => [
  {
    name: 'NBA Rotations',
    description: 'Research NBA player rotations and stints to optimize your lineups.',
    link: '/rotations',
    isMobileSupported: true,
    view: App.ROTATIONS,
  },
  {
    name: 'NBA Rates',
    description: 'Analyze NBA player performance with different lineup combinations on and off the floor.',
    link: '/nbarates/NBA',
    isMobileSupported: false,
    view: App.NBA_RATES,
  },
];

// Combined list for mobile drawer (keeps all items flat)
export const allPrimaryLinks = (league: string, queryParams: string, propsLeague: string = DEFAULT_PROPS_LEAGUE) => [
  ...primaryLinks(league, queryParams, propsLeague),
  ...simsLinks(league, queryParams),
  ...analyticsLinks(league, queryParams),
];

export const secondaryLinks = {
  default: [
    {
      name: 'Home',
      label: 'home',
      link: 'https://stokastic.com',
    },
    {
      name: 'Feedback',
      label: 'feedback',
      link: 'https://www.stokastic.com/single-lineup-simulator-feedback/'
    },
    {
      name: 'Help',
      label: 'help',
      link: 'https://www.stokastic.com/contact-us/'
    },
  ],
  NBA: [
    {
      name: 'Home',
      label: 'home',
      link: 'https://stokastic.com',

    },
    {
      name: 'Tutorials',
      label: 'tutorials',
      link: 'https://www.stokastic.com/nba-dfs-videos/'
    },
    {
      name: 'Feedback',
      label: 'feedback',
      link: 'https://www.stokastic.com/single-lineup-simulator-feedback/'
    },
    {
      name: 'Help',
      label: 'help',
      link: 'https://www.stokastic.com/contact-us/'
    },
  ]
};